<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert"/>
      任务列表
    </p>
    <template slot="extra">
    </template>
    <Row>
      <Col span="24">
      <Input v-model="query.jobName" placeholder="任务名称" class="public-inp md5"/>
      <Input v-model="query.beanName" placeholder="beanName" class="public-inp md5"/>
      <span class="public-stretch" @click="open = !open">
                <Icon :type="open?'ios-arrow-up':'ios-arrow-down'"/>{{open?'收起':'展开'}}
                </span>
      <Button type="primary" icon="md-add" class="public-fr" @click="addFn()">添加任务</Button>
      <Button class="public-fr" @click="reset()">重置</Button>
      <Button class="public-fr" type="primary" icon="ios-search" @click="getList()">查询</Button>
      </Col>
      <Col span="24">
      <Table
        :style="{marginTop:'10px'}"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList">
        <template slot-scope="{ row,index }" slot="sort">
          <span v-show="false">{{row.code}}</span>
          {{index+1}}
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a href="javascript:;" @click="editFn(row)">编辑</a>
          <span v-if="row.status==='0'" style="color:black;">
          <a href="javascript:;" @click="pauseFn(row)">停用</a>
          </span>
          <span v-if="row.status==='1'" style="color:black;">
          <a href="javascript:;" @click="runFn(row)">执行</a>
          </span>
          <a href="javascript:;" @click="resumeFn(row)">重启</a>
          </span>
          <a href="javascript:;" @click="resumeFn(row)">删除</a>
        </template>
      </Table>
      </Col>
    </Row>
  </Card>
</template>
<script>
  import columns from '@/views/task/columns';

  export default {
    data() {
      return {
        visiable: false,
        open: false,
        query: {
          jobName: '',
          beanName: '',
        },
        columns: columns.jobName,
        tbList: [],
        loading: false,
      }
    },
    created() {
      this.getList();
    },
    methods: {
      getList() {
        let data = this.query;
        this.loading = true;
        this.$api.scheduleAllTask(data).then(res => {
          this.loading = false;
          if (res.code == '200') {
            this.tbList = res.data;
          }
        })
      },
      reset() {
        Object.keys(this.query).forEach(i => {
          this.query[i] = '';
        });
        this.$nextTick(() => {
          this.getList();
        })
      },
      uploadToggle() {
        this.visiable = !this.visiable
      },
      // 页码
      pageChange(d) {
        this.getList();
      },
      // 页数
      pageSizeChange(d) {
        this.getList();
      },
      addFn() {
        this.$router.push({
          name: 'taskAdd'
        });
      },
      editFn(row) {
        this.$router.push({
          name: 'taskEdit',
          query: {
            jobId: row.jobId,
            jobName: row.jobName
          },
        });
      },
      removeFn(row) {
        this.$Modal.confirm({
          title: '提示',
          content: `确认删除${row.jobName}`,
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            this.$api.deleteScheduleTask(row.jobId, null).then((res) => {
              if (res.code == '200') {
                this.getList();
              } else {
                this.$Message.error(res.Message);
              }
            })
          }
        })
      },
      runFn(row) {
        this.$Modal.confirm({
          title: '提示',
          content: `确认执行任务[${row.jobName}]`,
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            this.$api.runScheduleTask(row.jobId, null).then((res) => {
              if (res.code == '200') {
                this.getList();
              } else {
                this.$Message.error(res.Message);
              }
            })
          }
        });
      },
      pauseFn(row) {
        this.$Modal.confirm({
          title: '提示',
          content: `确认停用任务[${row.jobName}]`,
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            this.$api.pauseScheduleTask(row.jobId, null).then((res) => {
              if (res.code == '200') {
                this.getList();
              } else {
                this.$Message.error(res.Message);
              }
            })
          }
        });
      },
      resumeFn(row) {
        this.$Modal.confirm({
          title: '提示',
          content: `确认重启任务[${row.jobName}]`,
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            this.$api.resumeScheduleTask(row.jobId, null).then((res) => {
              if (res.code == '200') {
                this.getList();
              }
            })
          }
        });
      }
    }
  }
</script>
<style scoped>
  .md5 {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/task/taskManage.vue